import { HashRouter, Link, Route, Routes } from "react-router";

import { LoginPage, SignupPage } from "./Views/Auth";
import OAuthAuthorizePage from "./Views/OAuth";
import ServersView from "./Views/Servers";
import VaultView from "./Views/Vault";

import ServerView from "./Views/Servers/Server";
import PackageView from "./Views/Vault/Package";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Link to="/auth/login">Login</Link>
              <br />
              <Link to="/auth/signup">Signup</Link>
              <br />
              <Link to="/servers">Servers</Link>
              <br />
              <Link to="/vault">Vault</Link>
            </>
          }
        />
        <Route path="/oauth2/authorize" element={<OAuthAuthorizePage />} />
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth/signup" element={<SignupPage />} />
        <Route path="/servers/:id" element={<ServerView />} />
        <Route path="/servers" element={<ServersView />} />
        <Route path="/vault" element={<VaultView />} />
        <Route path="/packages/:id" element={<PackageView />} />
        <Route path="*" element={<div>404 Not Found</div>} />
      </Routes>
    </HashRouter>
  );
}

export default App;
